import React from 'react';
import { avatarInitials } from '../../utils';

export default function Avatar({ name = '', color, src, size = 'md', className = '' }) {
  const sizes = { xs: 'w-5 h-5 text-[9px]', sm: 'w-6 h-6 text-[10px]', md: 'w-7 h-7 text-xs', lg: 'w-9 h-9 text-sm' };
  const bg = color || '#6366f1';

  if (src) {
    return (
      <img src={src} alt={name} title={name}
        className={`${sizes[size]} rounded-full object-cover flex-shrink-0 ring-1 ring-white/20 ${className}`} />
    );
  }

  return (
    <div
      className={`${sizes[size]} rounded-full flex items-center justify-center font-semibold text-white flex-shrink-0 ${className}`}
      style={{ background: bg }}
      title={name}
    >
      {avatarInitials(name)}
    </div>
  );
}

export function AvatarGroup({ users = [], max = 3 }) {
  const shown = users.slice(0, max);
  const rest = users.length - max;
  return (
    <div className="flex -space-x-1.5">
      {shown.map((u, i) => <Avatar key={u._id || i} name={u.name} color={u.color} src={u.avatar} size="sm" className="ring-2 ring-white dark:ring-gray-900" />)}
      {rest > 0 && <div className="w-6 h-6 rounded-full bg-gray-200 dark:bg-gray-700 ring-2 ring-white dark:ring-gray-900 flex items-center justify-center text-[10px] font-medium text-gray-600 dark:text-gray-300">+{rest}</div>}
    </div>
  );
}
